import { useMemo, useState } from 'react';
/**
 * Хук для трекания boolean при помощи useState.
 */
export const useBooleanState = (initialState) => {
    const [state, setState] = useState(initialState);
    const [setTrue, setFalse, toggle] = useMemo(() => [() => setState(true), () => setState(false), () => setState(state => !state)], []);
    return { state, setState, setTrue, setFalse, toggle };
};
